// File: assets/search-widget.js
// Shopify Predictive Search API integration

(function () {
  const input       = document.getElementById('searchInput');
  const dropdown    = document.getElementById('searchSuggestions');
  const category    = document.getElementById('searchCategory');
  const submitBtn   = document.getElementById('searchSubmit');
  const micBtn      = document.getElementById('micBtn');
  const wrapper     = document.getElementById('searchWidgetWrapper');
  const routes      = window.searchRoutes || {};

  let debounceTimer, currentQuery = '', activeIndex = -1;

  /* ---- Debounced input handler ---- */
  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const q = input.value.trim();
    if (q.length < 2) { closeDropdown(); return; }
    debounceTimer = setTimeout(() => fetchSuggestions(q), 280);
  });

  /* ---- Keyboard navigation ---- */
  input.addEventListener('keydown', (e) => {
    const items = dropdown.querySelectorAll('.suggestion-item');
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIndex = Math.min(activeIndex + 1, items.length - 1);
      updateActive(items);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIndex = Math.max(activeIndex - 1, -1);
      updateActive(items);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIndex >= 0 && items[activeIndex]) {
        items[activeIndex].click();
      } else {
        doSearch();
      }
    } else if (e.key === 'Escape') {
      closeDropdown();
    }
  });

  function updateActive(items) {
    items.forEach((el, i) => {
      el.classList.toggle('active', i === activeIndex);
    });
  }

  /* ---- Fetch from Shopify Predictive Search API ---- */
  async function fetchSuggestions(q) {
    currentQuery = q;
    showLoading();
    const col = category ? category.value : '';
    let url = `${routes.predictive || '/search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;
    if (col) url += `&resources[options][unavailable_products]=last&collection_handle=${col}`;

    try {
      const res  = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const text = await res.text();
      fetchJSON(q, col);
    } catch (err) {
      fetchJSON(q, col);
    }
  }

  /* ---- JSON Predictive Search (most reliable) ---- */
  async function fetchJSON(q, col) {
    let url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
    try {
      const res  = await fetch(url);
      const data = await res.json();
      const products = data?.resources?.results?.products || [];
      renderSuggestions(products, q);
    } catch {
      renderEmpty();
    }
  }

  /* ---- Render suggestions ---- */
  function renderSuggestions(products, q) {
    activeIndex = -1;
    if (!products.length) { renderEmpty(); return; }

    let html = `<div class="suggestions-section-label">Products</div>`;
    products.forEach(p => {
      const price  = formatPrice(p.price);
      const title  = highlightMatch(p.title, q);
      const imgSrc = p.image || p.featured_image?.url || '';
      html += `
        <a class="suggestion-item" href="${p.url}" role="option">
          <img src="${imgSrc}&width=80" alt="${escHtml(p.title)}" onerror="this.style.display='none'">
          <div class="suggestion-item-info">
            <div class="suggestion-item-title">${title}</div>
            <div class="suggestion-item-price">${price}</div>
          </div>
        </a>`;
    });
    html += `<div class="suggestions-footer" onclick="doSearch()">See all results for &ldquo;${escHtml(q)}&rdquo; &rarr;</div>`;
    dropdown.innerHTML = html;
    openDropdown();
  }

  function renderEmpty() {
    dropdown.innerHTML = `<div class="suggestions-empty">No results for &ldquo;${escHtml(currentQuery)}&rdquo;</div>`;
    openDropdown();
  }

  function showLoading() {
    dropdown.innerHTML = `<div class="suggestions-loading">Searching...</div>`;
    openDropdown();
  }

  function openDropdown()  { dropdown.classList.add('open'); }
  function closeDropdown() { dropdown.classList.remove('open'); activeIndex = -1; }

  /* ---- Submit search ---- */
  window.doSearch = function() {
    const q   = input.value.trim();
    if (!q) return;
    const col = category ? category.value : '';
    let url = `${routes.search || '/search'}?q=${encodeURIComponent(q)}&type=product`;
    if (col) url += `&filter.p.m.collection_handle=${col}`;
    window.location.href = url;
  };
  submitBtn.addEventListener('click', doSearch);

  /* ---- Voice Search ---- */
  const SpeechRec = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (SpeechRec) {
    const recognition = new SpeechRec();
    recognition.lang = 'en-US';
    recognition.onresult = (e) => {
      input.value = e.results[0][0].transcript;
      micBtn.classList.remove('listening');
      fetchSuggestions(input.value.trim());
    };
    recognition.onend = () => micBtn.classList.remove('listening');
    micBtn.addEventListener('click', () => {
      micBtn.classList.add('listening');
      recognition.start();
    });
  } else {
    micBtn.style.display = 'none';
  }

  /* ---- Close on outside click ---- */
  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) closeDropdown();
  });

  /* ---- Helpers ---- */
  function highlightMatch(text, q) {
    const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return escHtml(text).replace(new RegExp(escaped, 'gi'), m => `<mark>${m}</mark>`);
  }
  function escHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function formatPrice(price) {
    if (!price) return '';
    return '&#8377;' + parseFloat(price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
})();